import { Caption, LayoutSpaceVertical, Link } from 'breeze-intelligence-kit';
import { CreditsDisplay, CreditsDisplaySubscription } from './CreditsDisplay';
import { DisclaimerMessage, DisclaimerMessageOveragePanel } from '../DisclaimerText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCurrentUser } from 'policy-lib';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CreditsAvailable = ({
  hasLowCredits,
  isLoading,
  availableCredits
}) => {
  if (isLoading) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Caption, {
    maxInlineSize: "60ch",
    children: [/*#__PURE__*/_jsx(CreditsDisplay, {
      credits: availableCredits,
      hasLowCredits: hasLowCredits
    }), ". ", /*#__PURE__*/_jsx(DisclaimerMessage, {})]
  });
};
export const CreditsAvailableOverage = ({
  availableCredits,
  hasLowCredits,
  hasOverage,
  isLoading,
  totalUsage,
  usageLimit
}) => {
  const currentUser = useCurrentUser();
  const href = `/account-dashboard/${currentUser.portalId}/usage`;
  if (isLoading) {
    return null;
  }
  const Credits = () => hasOverage ? /*#__PURE__*/_jsx(CreditsDisplaySubscription, {
    hasLowCredits: hasLowCredits,
    totalUsage: totalUsage,
    usageLimit: usageLimit
  }) : /*#__PURE__*/_jsx(CreditsDisplay, {
    credits: availableCredits,
    hasLowCredits: hasLowCredits
  });
  return /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
    gap: "0",
    maxInlineSize: "60ch",
    children: [/*#__PURE__*/_jsx(Caption, {
      children: /*#__PURE__*/_jsx(Credits, {})
    }), /*#__PURE__*/_jsxs(Caption, {
      children: [/*#__PURE__*/_jsx(DisclaimerMessageOveragePanel, {}), /*#__PURE__*/_jsx(Link, {
        href: href,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "enrichmentCredits.disclaimerOverageLink"
        })
      })]
    })]
  });
};